// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_PORTFOLIO_CHARTS_DATA = "GET_PORTFOLIO_CHARTS_DATA";
export const GET_MARKET_CHARTS_DATA = "GET_MARKET_CHARTS_DATA";